<template>
  <div>
    <Mainlayout></Mainlayout>
    <!-- badan page -->
    <CCard class="custom-card h-100 mt-5">
      <CCol sm="12" class="justify-content-center">
        <CContainer>
          <CCol>
            <br />
              <div class="d-sm-flex d-md-none"><br /></div>
            <CRow>
              <!-- perkataan 'Score Card' -->
              <h4 class="text-left ml-2 text-black bold" style="font-size:24px">Score Card</h4>

              <!-- Menu Subject -->
              <div class="col-lg-12 mt-2">
                <CRow>
                  <CCol>
                        <br />

                        <!-- Score Overview -->
                        <CCard
                          style="border-color: #80b3ff; border-radius: 15px"
                          class="text-center box-shadow"
                          body-wrapper
                          text-color="black"
                          color="light"
                        >
                          <CRow class="col-14">
                            <CCol class="col-6">
                              <div class="text-center">
                                <p style="font-size:15px;">Score Overview All Subject</p>

                                <vue-ellipse-progress
                          :data="circles"                    
                          :progress="qSummary.averageScore"
                          :angle="-90"
                          :color="GetColor(qSummary.averageScore.toFixed(2))"
                          :colorFill="colorFillGradient"
                            emptyColor="#009688"
                          :emptyColorFill="emptyColorFillGradient"                      
                          :size="130"
                          :thickness="9"
                            emptyThickness="8%"
                            lineMode="in 7"
                          :legend="true"
                          :legendValue="qSummary.averageScore.toFixed(2)"
                            legendClass="legend-custom-style"
                            dash="50 0.9"
                            animation="reverse 700 400"
                          :noData="false"
                          :loading="false"                      
                            fontColor="green"
                          :half="false"
                          :gap="5"
                            dot="10"
                            fontSize="1.2rem">
                          <span slot="legend-value">%</span>
                                </vue-ellipse-progress>
                              </div>
                            </CCol>

                            <CCol class="col-6 text-left">
                              <CRow class="col-8">
                                <p>Today score</p>
                                <p style="font-size:20px;">
                               <span class="d-sm-down-none"><br /></span>
                                  <strong>
                                    {{ qSummary.todayHighScore.toFixed(2)}}
                                  </strong>
                                </p>
                              </CRow>
                              <hr />

                              <CRow class="col-8">
                                <p>This year score</p>
                                <p style="font-size:20px;">
                                  <span class="d-sm-down-none"><br /></span>
                                  <strong>
                                    {{ qSummary.totalScore.toFixed(2)}}
                                    </strong>
                                </p>
                              </CRow>
                            </CCol>
                          </CRow>
                        </CCard>

                        <!-- Pointed Chart -->
                        <CCard
                          style="border-color: #80b3ff; border-radius: 15px;"
                          class="text-left box-shadow"
                          body-wrapper
                          text-color="black"
                          color="light"
                        >
                          <CRow>
                            <div class="col-8">
                              <CIcon class="cilc" name="cil-chart-line" width="20px" height="20px" />
                              <br />
                            </div>
                            <div class="col-8">
                              <p style="font-size:20px;">
                                <strong>
                                  Subject Statistic
                                  </strong>
                              </p>
                            </div>
                            <div class="col-11">
                              <CChartBar
                                style="height:300px"
                                :datasets="defaultDatasets"
                                :options="defaultOptions"
                                :labels="['Bahasa Melayu', 'Bahasa Inggeris', 'Mathematic', 'Science', 'Geografi', 'Sejarah', 'Pendidikan Islam', 'Pendidikan Moral', 'Add Math', 'Physics', 'Chemistry', 'Biology']"
                              />
                            </div>
                          </CRow>
                        </CCard>

                        <!-- Current streak -->
                        <CCard
                          style="border-color: #80b3ff; border-radius: 15px"
                          class="gradient box-shadow"
                          body-wrapper
                          text-color="black"
                          color="light"
                        >
                          <CRow class="col-14">
                            <CCol>
                              <CIcon
                                class="cilc"
                                name="cil-reload"
                                width="20px"
                                height="20px"
                                style="align-left"
                              />
                              <p style="font-size:15px;" class="mt-2">Current streak</p>
                              <p style="font-size:20px;">
                                <strong>1 Days</strong>
                              </p>
                            </CCol>
                            <CCol>
                              <CIcon
                                class="cilc"
                                name="cil-loop-circular"
                                width="20px"
                                height="20px"
                              />
                              <p style="font-size:15px;" class="mt-2">Longest streak</p>
                              <p style="font-size:20px;">
                                <strong>6 Days</strong>
                              </p>
                            </CCol>
                          </CRow>
                        </CCard>

                        <!-- Total Quizzes-->
                        <CCard
                          style="border-color: #80b3ff; border-radius: 15px"
                          class="gradient box-shadow"
                          body-wrapper
                          text-color="black"
                          color="light"
                        >
                          <CRow class="col-14">
                            <CCol class="col-6">
                              <CIcon class="cilc" name="cil-pencil" width="20px" height="20px" />
                              <p style="font-size:15px;" class="mt-2">Total Quizzes</p>
                              <p style="font-size:20px;">
                                <strong>
                                  {{ qSummary.totalQuiz }}
                                   Quizzes</strong>
                              </p>
                            </CCol>
                            <CCol class="col-6">
                              <CIcon class="cilc" name="cil-history" width="20px" height="20px" />
                              <p style="font-size:15px;" class="mt-2">Last quiz submission</p>
                              <p style="font-size:20px;">
                                <strong>
                                  {{ qSummary.lastSubmitQuizDate | moment("DD MMM YYYY") }}
                                  </strong>
                              </p>
                            </CCol>
                          </CRow>
                        </CCard>
                  </CCol>
                </CRow>
              </div>
            </CRow>
          </CCol>
        </CContainer>
      </CCol>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import Mainlayout from "../containers/TheHeaderWebStudent.vue";

import { CChartBar } from '@coreui/vue-chartjs'
import { getColor, deepObjectsMerge } from '@coreui/utils/src';
import VueEllipseProgress from 'vue-ellipse-progress';
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
Vue.use(VueEllipseProgress);
import _ from "lodash";

export default {
  name: "Login",
  components: {
    CChartBar,
    Mainlayout
  },

  data() {
    return {
      qSummary: {},
      Error: false,
      ErrorNoData: false,
      toFixed: "",
      
    };
  },
  // Chart
  computed: {
    defaultDatasets () {
      return [
        {
          label: 'Average Subject Score',
          backgroundColor: '#009688',
          data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
        }
      ]
    },
    defaultOptions () {
      return {
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              max: 100
            },
            gridLines: {
              display: true
            }
          }]
        }
      }
    }
  },

  async mounted() {
    this.GetQuizStudentStatisticAverageScore();
    //this.GetColor();
  },
  methods: {
    //Get quiz summary
    GetQuizStudentStatisticAverageScore() {
      this.$API
        .get(
          this.$QuizStudentStatisticAverageScore +
            "?studentId=" +
            this.$route.query.studentId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
          this.qSummary = response.data;

          console.log("test" + this.qSummary.averageScore);
        this.GetColor(this.qSummary.averageScore);
          }
          else
          {
            this.Error = true;
          }
        })
        .catch(function(error) {
          console.log(error.response);
        });
    },
    GetColor: function (averageScore) {
      console.log("e" + averageScore);

      if (averageScore <= 39) {
        return "red";
      } else if (averageScore <= 79) {
        return "yellow";
      } else if (averageScore >= 80) {
        return "green";
      }
      return "";
    }
  }
};
</script>

<style>
.cilc {
  background: rgba(32, 161, 180, 1);
  border-radius: 45%;
  background-size: 200px;
}
</style>